<template>
  <div class="popup-wrapper" @click.self="close">
    <!-- <div class="popup-action">
      <div class="button button-submit">
        <button class="btn" type="submit" name="note_order_settings"
          @click="submit"
        >決定
        </button>
      </div>
      <div class="button button-close">
        <button class="btn" @click="close">
          <FontawesomeIcon :icon="['fal','times']" size="lg" class="icn" />
        </button>
      </div>
    </div> -->
    <div class="popup-container">
      <div class="popup">
        <div class="popup-title">
          <span v-if="common.systemError.type === 'TimeOut'" class="popup-title-main">タイムアウト</span>
          <span v-else class="popup-title-main">システムエラー</span>
        </div>
        <div class="popup-content">
          <p class="txt" v-if="common.systemError.type === 'TimeOut'">タイムアウトしました。ログイン画面に戻り、ログインし直してください。</p>
          <p class="txt" v-else>申し訳ございません。システムエラーが発生しました。ブラウザを閉じて再度やり直してください。</p>
          <div class="button mt32"
            @click="move"
            >
            <a @click="move" class="txt-blue" role="button" to="/sp/login">ログイン画面へ</a>
          </div>
          <div class="button mt32"
            v-if="common.systemError.button.show"
            @click="submit"
            >
            <span role="button" class="btn">{{common.systemError.button.text}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, ref, computed } from '@vue/composition-api'

export default defineComponent({

  setup (props, context) {
    const store = context.root.$store
    const router = context.root.$router
    const {common} = store.state

    const state = reactive({
      isOpenHistoryTags: false
    })
    const close = () => {
      context.emit('closeSystemError')
    }
    const submit = () => {
      context.emit('closeSystemError')
      store.dispatch('common/hideError')
    }
    const move = () => {
      context.emit('closeSystemError')
      store.dispatch('common/hideError')
      router.push({ path: '/sp/login'})
    }
    
    return {
      common,
      state,
      close,
      submit,
      move
    }
  }
})
</script>

<style lang="scss" scoped>
.popup {
  &-title {
    background-color: $color-link;
    border-top-right-radius: 8px;
    &-main {
      color: #fff!important;
    }
  }
  &-content {
    padding: 20px;
    .button {
      max-width: 240px;
      margin: 0 auto;
    }
  }
}
</style>
